module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("页面上的值:  " + _vm._s(_vm.my_value) + " ")]), _vm._v(" "), _c('p', [_vm._v(" 通过视图层，修改my_value: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.my_value),
      expression: "my_value"
    }],
    staticStyle: {
      "width": "400px"
    },
    domProps: {
      "value": (_vm.my_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.my_value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "通过控制代码修改my_value"
    },
    on: {
      "click": function($event) {
        _vm.change_my_value_by_code()
      }
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "显示代码中的my_value"
    },
    on: {
      "click": function($event) {
        _vm.show_my_value()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56a3eba3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TwoWayBinding.vue
// module id = 66
// module chunks = 0